import { Icon } from '../Icon';
import type { IconProps } from '../types';

export function ChevronUpIcon(props: IconProps) {
  return (
    <Icon {...props}>
      <path d="M11.293 8.293a1 1 0 0 1 1.414 0l6 6a1 1 0 0 1-1.414 1.414L12 10.414l-5.293 5.293a1 1 0 0 1-1.414-1.414z" />
    </Icon>
  );
}

ChevronUpIcon.displayName = 'ChevronUpIcon';
